import { Node } from '@tiptap/vue-2';

/**
 * Basic block and nestable div node extension.
 */
export const ArticleExtension = Node.create({
  name: 'article',
  group: 'block',
  content: 'block+',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'article',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['article', HTMLAttributes, 0];
  },
});
